import React from "react";
import { keyframes, styled } from "@mui/material/styles";
import Badge from "@mui/material/Badge";
import { Box } from "@mui/material";
import { round } from "lodash";

// Pulse Effect for Badge Glow
const pulseEffect = keyframes`
    0%, 100% { box-shadow: 0 0 0px rgba(231, 180, 0, 0); }
    50% { box-shadow: 0 0 20px rgba(231, 180, 0, 0.8); }
`;

// Shake Effect for Number
const shakeEffect = keyframes`
    0%, 100% { transform: translateX(0); }
    20%, 60% { transform: translateX(-1px); }
    40%, 80% { transform: translateX(1px); }
`;

// Styled Badge Component
const StyledBadge = styled(Badge, {
    shouldForwardProp: (prop) => prop !== 'animationKey' && prop !== 'isMobile'
})(({ animationKey, isMobile = false }) => ({
    "& .MuiBadge-badge": {
        right: isMobile ? 19 : 24,
        color: "#fff",
        fontSize: isMobile ? "10px" : "14px",
        top: isMobile ? 35 : 32,
        borderRadius: isMobile ? '4px' : '5px',
        marginRight: '1px',
        height: isMobile ? '24px' : '30px',
        width: '69%',
        transition: "width 0.7s ease, font-size 0.8s ease",
        animation: `${pulseEffect} 1.5s ease`, // Always animate
        animationIterationCount: "1", // Run animation only once per key change
        animationKey, // Trigger animation when key changes
    },
}));

// Container for Shaking Number
const AnimatedCountContainer = styled(Box)`
    display: inline-block;
    position: relative;
`;

// Number with Shake Animation
const AnimatedCount = styled(Box)`
    display: inline-block;
    animation: ${shakeEffect} 0.5s ease;
`;

const LockedCustomBadge = ({
    count,
    background,
    icon: IconComponent,
    iconProps = {},
    animationKey,
    isMobile = false
}) => {
    const badgeStyles = {
        ".MuiBadge-badge": {
            background,
            ...(count && Math.round(count).toString().length === 5 && {
                width: "80% !important",
                fontSize: "13.5px",
            }),
            ...(count && Math.round(count).toString().length >= 6 && {
                width: "84% !important",
                fontSize: "12px",
            }),
        },
    };

    const badgeContent = (
        <AnimatedCountContainer>
            <AnimatedCount key={animationKey}>
                {round(count)}
            </AnimatedCount>
        </AnimatedCountContainer>
    );

    return (
        <StyledBadge
            sx={badgeStyles}
            badgeContent={badgeContent}
            color="success"
            max={9999999}
            key={animationKey} // Restart animation on key change
            animationKey={animationKey}
            isMobile={isMobile}
        >
            <IconComponent
                sx={{
                    fontSize: isMobile ? 40 : 51,
                    color: "#E7B400",
                    animation: "background-fade 2s forwards",
                    "@keyframes background-fade": {
                        "99.9%": {
                            color: "#E7B400"
                        },
                    },
                    ...(isMobile && {
                        marginTop: "10px",
                        fontSize: "40px"
                    })
                }}
                {...iconProps}
            />
        </StyledBadge>
    );
};

export default LockedCustomBadge;
